export const GET_DETAIL = {
    REQUEST: 'DELIVERY_NOTE.RETURN.GET_DETAIL.REQUEST',
    SUCCESS: 'DELIVERY_NOTE.RETURN.GET_DETAIL.SUCCESS',
    FAILED: 'DELIVERY_NOTE.RETURN.GET_DETAIL.FAILED',
};

export const SET_DETAIL = 'DELIVERY_NOTE.RETURN.SET_DETAIL';

export const CLEAR_STATE = 'DELIVERY_NOTE.RETURN.DETAIL.CLEAR_STATE';
